import { VALIDATE_TOKEN, LOGIN_FAILED } from '../action-types'

const initialState = { current: {}, loginFailed: false }
const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case VALIDATE_TOKEN:
      return { ...state, current: payload, loginFailed: false }
    case LOGIN_FAILED:
      return { ...state, loginFailed: true }
    default:
      return state
  }
}
export default userReducer